module.exports = __webpack_public_path__ + "static/img/tips.4cfd7f50.png";